export const articles = [
  {
    id: 1,
    title: 'Photoshop 图层混合模式完全指南：从原理到实战',
    summary: '深入解析 Photoshop 中 27 种图层混合模式的数学原理和实际应用场景，配合大量案例演示如何用混合模式快速实现光效、质感、色彩调整等效果。',
    category: '图像处理',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20digital%20workspace%20showing%20Photoshop%20interface%20with%20layer%20blending%20modes%20panel%20open%20on%20modern%20monitor%20clean%20minimalist%20setup%20with%20soft%20purple%20and%20white%20tones%20professional%20photography%20style%20high%20quality%20detailed%20view&width=800&height=500&seq=article1&orientation=landscape',
    author: {
      name: '林小雨',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20female%20designer%20portrait%20friendly%20smile%20creative%20workspace%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author1&orientation=squarish'
    },
    publishDate: '2025-01-15',
    readTime: 25,
    likes: 2847,
    bookmarks: 1523,
    comments: 186,
    tags: ['混合模式', 'Photoshop', '图层', '后期处理']
  },
  {
    id: 2,
    title: 'UI 设计中的微交互：提升用户体验的 15 个细节',
    summary: '微交互是 UI 设计中最容易被忽视却最能提升体验的部分。本文总结 15 个常见场景的微交互设计技巧，包括按钮反馈、加载动画、表单验证等。',
    category: '数字媒体设计',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20UI%20design%20interface%20showing%20micro%20interactions%20and%20animations%20on%20sleek%20mobile%20app%20screen%20clean%20gradient%20background%20purple%20and%20teal%20accents%20professional%20design%20showcase%20high%20quality&width=800&height=500&seq=article2&orientation=landscape',
    author: {
      name: '张晓明',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20male%20designer%20portrait%20glasses%20confident%20expression%20modern%20office%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author2&orientation=squarish'
    },
    publishDate: '2025-01-12',
    readTime: 18,
    likes: 3156,
    bookmarks: 1847,
    comments: 234,
    tags: ['UI设计', '微交互', '用户体验', '动效']
  },
  {
    id: 3,
    title: 'AI 辅助设计工作流：从 Midjourney 到 Photoshop 的完整流程',
    summary: '详细讲解如何将 AI 生成的图像与传统设计工具结合，建立高效的创作流程。包括提示词优化、图像精修、风格统一等关键步骤。',
    category: 'AI创作',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20AI%20design%20workflow%20visualization%20showing%20connection%20between%20artificial%20intelligence%20and%20design%20tools%20futuristic%20purple%20gradient%20background%20clean%20modern%20aesthetic%20professional%20quality&width=800&height=500&seq=article3&orientation=landscape',
    author: {
      name: '王小美',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20female%20creative%20designer%20portrait%20artistic%20style%20colorful%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author3&orientation=squarish'
    },
    publishDate: '2025-01-10',
    readTime: 22,
    likes: 4231,
    bookmarks: 2654,
    comments: 312,
    tags: ['AI设计', 'Midjourney', 'Photoshop', '工作流']
  },
  {
    id: 4,
    title: '色彩理论在数字媒体设计中的应用：从配色到情绪传达',
    summary: '系统讲解色彩三要素、配色原则、色彩心理学在设计中的实际应用，配合大量案例分析不同色彩方案如何影响用户感知和情绪。',
    category: '数字媒体设计',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20color%20theory%20visualization%20with%20color%20wheel%20and%20palette%20swatches%20arranged%20artistically%20on%20clean%20white%20surface%20professional%20design%20education%20style%20high%20quality%20detailed&width=800&height=500&seq=article4&orientation=landscape',
    author: {
      name: '李明',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20male%20creative%20director%20portrait%20stylish%20appearance%20modern%20studio%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author4&orientation=squarish'
    },
    publishDate: '2025-01-08',
    readTime: 20,
    likes: 2934,
    bookmarks: 1678,
    comments: 198,
    tags: ['色彩理论', '配色', '设计心理学', '视觉设计']
  },
  {
    id: 5,
    title: 'Illustrator 钢笔工具从入门到精通：路径绘制技巧全解析',
    summary: '钢笔工具是矢量设计的核心，但很多人用不好。本文从基础操作到高级技巧，系统讲解如何用钢笔工具绘制流畅的曲线和复杂图形。',
    category: '工具技巧',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20vector%20illustration%20workspace%20showing%20Illustrator%20pen%20tool%20in%20action%20creating%20smooth%20curves%20clean%20modern%20interface%20purple%20accents%20high%20quality%20detailed%20view&width=800&height=500&seq=article5&orientation=landscape',
    author: {
      name: '陈小雅',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20female%20illustrator%20portrait%20creative%20expression%20artistic%20workspace%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author5&orientation=squarish'
    },
    publishDate: '2025-01-05',
    readTime: 16,
    likes: 2567,
    bookmarks: 1432,
    comments: 167,
    tags: ['Illustrator', '钢笔工具', '矢量绘制', '路径']
  },
  {
    id: 6,
    title: '视频剪辑节奏感训练：如何让你的作品更有感染力',
    summary: '节奏是视频的灵魂。从音乐节拍分析到镜头切换时机，详细讲解如何通过节奏控制提升视频的观看体验和情绪表达。',
    category: '项目复盘',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20video%20editing%20timeline%20interface%20showing%20rhythm%20and%20beat%20markers%20synchronized%20with%20audio%20waveforms%20professional%20editing%20software%20clean%20purple%20theme%20high%20quality&width=800&height=500&seq=article6&orientation=landscape',
    author: {
      name: '赵大伟',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20male%20video%20editor%20portrait%20focused%20expression%20editing%20suite%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author6&orientation=squarish'
    },
    publishDate: '2025-01-03',
    readTime: 19,
    likes: 3421,
    bookmarks: 1987,
    comments: 245,
    tags: ['视频剪辑', '节奏', '剪辑技巧', '后期制作']
  },
  {
    id: 7,
    title: '学习设计的正确姿势：我的一年成长复盘',
    summary: '从零基础到接单，分享我这一年学习数字媒体设计的完整路径、踩过的坑、有效的学习方法，以及如何建立自己的作品集。',
    category: '学习总结',
    coverImage: 'https://readdy.ai/api/search-image?query=Inspiring%20personal%20growth%20journey%20visualization%20with%20timeline%20milestones%20and%20achievement%20markers%20motivational%20purple%20gradient%20background%20clean%20modern%20design%20high%20quality&width=800&height=500&seq=article7&orientation=landscape',
    author: {
      name: '林小雨',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20female%20designer%20portrait%20friendly%20smile%20creative%20workspace%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author1&orientation=squarish'
    },
    publishDate: '2025-01-01',
    readTime: 28,
    likes: 5234,
    bookmarks: 3421,
    comments: 456,
    tags: ['学习方法', '成长复盘', '作品集', '经验分享']
  },
  {
    id: 8,
    title: 'Stable Diffusion 提示词工程：如何写出高质量的 Prompt',
    summary: '提示词是 AI 绘画的关键。详细讲解提示词的结构、权重控制、负面提示词使用，以及如何通过迭代优化得到理想的生成结果。',
    category: 'AI创作',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20prompt%20engineering%20interface%20showing%20text%20input%20and%20generated%20artwork%20preview%20clean%20technological%20aesthetic%20purple%20and%20cyan%20accents%20professional%20quality&width=800&height=500&seq=article8&orientation=landscape',
    author: {
      name: '张晓明',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20male%20designer%20portrait%20glasses%20confident%20expression%20modern%20office%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author2&orientation=squarish'
    },
    publishDate: '2024-12-28',
    readTime: 21,
    likes: 3876,
    bookmarks: 2345,
    comments: 289,
    tags: ['Stable Diffusion', '提示词', 'AI绘画', 'Prompt']
  },
  {
    id: 9,
    title: '人像精修的 10 个关键步骤：从磨皮到质感重塑',
    summary: '商业人像精修不只是磨皮那么简单。系统讲解从基础修瑕、中性灰磨皮、五官精修到质感重塑的完整流程，让你的人像更专业。',
    category: '图像处理',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20retouching%20before%20and%20after%20comparison%20showing%20skin%20texture%20enhancement%20split%20screen%20view%20clean%20studio%20background%20high%20quality%20detailed&width=800&height=500&seq=article9&orientation=landscape',
    author: {
      name: '王小美',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20female%20creative%20designer%20portrait%20artistic%20style%20colorful%20background%20natural%20lighting%20high%20quality%20professional%20headshot&width=100&height=100&seq=author3&orientation=squarish'
    },
    publishDate: '2024-12-25',
    readTime: 24,
    likes: 4123,
    bookmarks: 2567,
    comments: 312,
    tags: ['人像精修', '磨皮', '质感', '商业修图']
  }
];